<template>
  <div>
    <div class="cont-xw clearfix">
      <div class="jg-head">产品图片</div>
      <div style="overflow: hidden" class="text-center">
        <div class="text-center">
          <img
            class="form-group col-md-6 col-xs-6 col-sm-6"
            style="float:none"
            src="../../common/images/BU01PB.jpg"
          />
          <div @click="riseup" class="btn btn-success btn-circle top text-center">上升</div>
          <div>
            <a href="#fast" type="button" class="btn btn-danger btn-circle download text-center">下载</a>
          </div>
        </div>
      </div>
      <div class="jg-head">产品概述</div>
      <p>IVF-BU01PB是在第一代UHF蓝牙读卡器BU01上面的第二种延伸，可通过蓝牙接口与windows、ios、android等智能系统平台连接，当作模拟键盘使用。设备配备的手掌带上带有按键读取标签，无需二次开发，并兼容各种应用软件，便于各种场合的应用。</p>
      <div class="jg-head">参数规格</div>
      <p>支持超高频（UHF）标签协议ISO18000-6C</p>
      <p>支持系统：支持系统：Windows、IOS、Android</p>
      <p>通信接口：BLE4.0 HID</p>
      <p>读取距离：50cm（视标签大小而定）</p>
      <p>工作时长：连续工作3小时以上（最频繁的不断按键情况），可查询3万次</p>
      <p>材料：ABS+PC工程塑料</p>
      <p>电池容量：500mA</p>
      <p>充电方式：USB 5V/0.5A，充电2小时</p>
      <p>指示灯：电源指示灯、蓝牙指示灯、状态指示灯</p>

      <p>蜂鸣器：内置蜂鸣器</p>

      <p>开关：拨扭开关、按键触发读取</p>

      <p>工作环境温度：-20℃~60℃</p>
      <div class="jg-head">指示灯状态</div>
      <p>中间灯:</p>
      <p>①、正常工作：绿灯长亮</p>
      <p>②、设备异常：灯不亮</p>
      <p>③、电 量 低：绿灯一直缓慢闪烁（低电报警，请尽快充电）</p>
      <p>④、电量超低：绿灯一直快速闪烁（低电停止使用，无法读卡）</p>
      <p>⑤、充 电 中：红灯长亮</p>
      <p>⑥、充电完成：红灯灭掉</p>
      <p>左边灯:</p>
      <p>①、蓝牙连接成功：绿灯长亮</p>
      <p>②、蓝牙传输数据：绿灯快闪</p>
      <p>右边灯:</p>
      <p>①、操作标签成功：绿灯闪烁</p>
      <div class="jg-head">应用特点</div>
      <div>无需APP、无需驱动，不分系统平台，即连即用；</div>
      <div class="jg-head">使用方法</div>
      <p>蓝牙HID键盘，使用需要注意输入法要在英文字母输入状态(如下图一)；</p>
      <p>1.设备开机上电；</p>
      <p>2.在手机者平或板设置里面，配置连接产品对应编号的蓝牙连接(如下图二)；</p>
      <p>3.打开文本或者word等输入框(如下图三)；</p>
      <p>4.靠近标签读取即可在终端显示EPC。</p>
      <div class="box">
        <div class="box-row">
          <img class="content" src="../../common/images/BU01KB-1.jpg" />
          <img class="content" src="../../common/images/BU01KB-2.jpg" />
        </div>
        <div class="box-row">
          <img class="content" src="../../common/images/BU01KB-3.jpg" />
        </div>
      </div>
      <div id="fast" class="jg-head">下载</div>
      <ul>
        <li class="form-group">
          <FileDownload href="/static/IVF-BU/IVF-BU01PB规格书.doc">产品规格书</FileDownload>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FileDownload from "@/base/filedownload";
export default {
  data() {
    return {};
  },

  methods: {

    riseup() {
        riseup()
      }

      
  },

  
  components: {
    FileDownload
  }
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/BU/01PB.vue